'use client'

import { ReactNode } from 'react'
import { PublicModeProvider } from '@/lib/PublicModeContext'
import { ViewModeProvider } from '@/lib/ViewModeContext'
import { MobileSidebarProvider } from '@/lib/MobileSidebarContext'

// Объединяет все провайдеры приложения
export function Providers({ children }: { children: ReactNode }) {
  return (
    <PublicModeProvider>
      <ViewModeProvider>
        <MobileSidebarProvider>
          {children}
        </MobileSidebarProvider>
      </ViewModeProvider>
    </PublicModeProvider>
  )
}
